import {Card, CardActionArea, CardActions, Stack, Typography, useTheme} from '@mui/material';
import React from 'react';

import Icon from 'presentation/icons';
import {useAccountInformation} from 'presentation/pages/private/hooks';
import {translations} from 'presentation/translations-new';

const {logOut} = translations['pt-br'].privateFlow.profile;

export function SignOutField() {
	const {palette} = useTheme();

	const {handleLogout} = useAccountInformation();

	return (
		<CardActionArea onClick={handleLogout}>
			<Card elevation={0} sx={{p: 2}}>
				<CardActions>
					<Stack direction="row" spacing={1} alignItems="center">
						<Icon name="exit-to-app-filled" color={palette.error.main} />
						<Typography variant="body2" color={palette.error.main}>
							{logOut}
						</Typography>
					</Stack>
				</CardActions>
			</Card>
		</CardActionArea>
	);
}
